import React from "react";
import { StyledDivider } from "./Divider.styled";
import { DividerProps as MuiDividerProps } from "@mui/material";

export interface DividerProps extends MuiDividerProps {
  color: "light" | "dark";
}

export default function Divider({ color = "dark", ...props }: DividerProps) {
  return (
    <StyledDivider
      color={color}
      aria-orientation={props.orientation}
      {...props}
    />
  );
}
